import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jswitch(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
 <Sides/>
 <Helmet>
 
  <title>Java Switch tutorial For Beginners</title>
<meta name="description" content="Java Switch tutorial for beginners.This Switch case in java is also used in multiple conditions having different statements like- if else if but it can check only equality of the condition floating point but value can’t be check by the switch." />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java switch,java switch statement,java switch case,switch case in java,java switch string,java switch on string,java switch enum,java switch example,java switch case string,java switch default,java switch multiple case,can java minecraft play with switch,java switch case multiple values,java switch expression
,java switch instanceof,java 8 switch case,java switch method,java switch case enum
" />
<link rel="canonical" href="https://www.codeexampler.com/java-switch" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Switch Case in Java</h1>
    <div className="first">
        <a href="/java-conditional-operator">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-looping">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Switch statement in Java:</h2>
<p className="mt-4 para">This Switch case in java is also used in multiple conditions having different statements like- if-else-if but it can check only equality of the condition floating point but value can’t be check by the switch.</p>
<h3 className="mt-4 mh3" >Syntax for the switch in java:</h3>


<h2 className="headings">Q-Write a program to input a no and print month name and if no is 2?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
      
     
  {"\n"} 

  <span className="qwerty-6">switch</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">variable</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&#123; </span>
  {"\n"}


  <span className="qwerty-6">&nbsp;case </span>
  <span className="qwerty-1">1</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;Statement ;</span>

  {"\n"}


  <span className="qwerty-6">&nbsp;case </span>
  <span className="qwerty-1">2</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;Statement ;</span>

  {"\n"}
  <span className="qwerty-6">&nbsp;default</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;Statement ;</span>
      {"\n"}

          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
        </code>
      </pre>        
    </div>


<p className="mt-4 para">In this  Switch case keyword in java programming  that will yield an integer value forex-case1,case2, etc this is an integer constant<br/>
if you do not find any match with any of these case statements so on that time default statement is executed 
</p>
<h2 className="mt-4 mh2">Switch case in java Example Programs</h2>



<h2 className="headings">Q-Write a program to input a no and print month name and if no is 2?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Switch_example </span><span className="qwerty-5">{`// class is a keyword`}</span> 
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">1</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-1">3;</span>
      
     
  {"\n"} 

  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;switch</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp; </span>
  {"\n"}



  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">1</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"January"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}




  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">2</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"February"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}


  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">3</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"March"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}


  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;default</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"default value"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}


 


      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}
 
 
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}


          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-5">&nbsp;March </span>  
          {"\n"}   
          <span className="qwerty-3">&nbsp;default value  </span>  
          {"\n"}   
       
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Q-Write a Program without input use switch case?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Switch_example </span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">1</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-1">24;</span>
      
     
  {"\n"} 

  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;switch</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}


  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">22</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"22"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}


  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">23</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"23"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}




  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">24</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"24"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}


  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">25</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"25"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}


  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;default</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"default value"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}


 

      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}
 
 
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}


          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-5">&nbsp;24 </span>  
          {"\n"}   

          <span className="qwerty-5">&nbsp;25 </span>  
          {"\n"}   

          <span className="qwerty-3">&nbsp;default value  </span>  
          {"\n"}   
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<p className="mt-4 para">This program gives output but not what we expected because we did not give the output of case 3 and the default value 
Break switch statement:<br/>
so if you want to give the only case 2 statement so using switch break java means switch case break java statement
</p>
<h2 className="mt-4 mh2">Java switch statement Break</h2>


<h2 className="headings">Q-Write a Program to give a no and print month name and if no is 2 by using switch break java?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Switch_example </span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">1</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-1">3;</span>
      
     
  {"\n"} 

  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;switch</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>{"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`//Case statements`}  </span>
  {"\n"}



  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">1</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"jan"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}




  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">2</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"feb"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}


  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">3</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"mar"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}


  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;default </span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"default value"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}


 

      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}
 
 
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}


          <span className="qwerty-3">&#125; </span>
            {"\n"}
     </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;mar </span>  
          {"\n"}   
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="headings">Q-Write a Program Character switch case in Java?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Switch_example </span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;char </span>
      <span className="qwerty-4">x</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-1">'c';</span>
      
     
  {"\n"} 

  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;switch</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">x</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>{"\n"}
  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">'a'</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"w"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}




  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">'b'</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"x"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}




  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">'c'</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"y"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}


  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">'d'</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"z"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}


  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;default </span>
  <span className="qwerty-8"> : </span>
  <span className="qwerty-5">{`//This is a Default statement in java switch `}  </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"default value"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}


 

      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}
 
 
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}


          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;y </span>  
          {"\n"}   
       
            </code>{"   "}
            </pre>
      </div>
    </div>
    


<h2 className="mt-4 mh2">Use for loop in Switch Case Java
</h2>
<h3 className="mt-4 mh3">Following for loop step In switch case with break :
</h3>
<p className="mt-4 para">1, Give java I am an int<br/>
2, After start for loop  from 1 to 5 and also use I inside switch  <br/>
3, After case 1 and check no. if no is the same so print 1 and after the break.<br/>
4, After the break. Increasing the value of loop counter each time when the program segment within the loop has been executed because (i++) is used <br/>
5, In this time loop, started from 2 by the use of increment.check  2 in case if 2 is found so print 2 and break and again start loop <br/>
6, When i=6 this is not greater than 5 so loop stop on 5<br/>
</p>

<h2 className="headings">Q-Write a Program Example for loop in switch case java?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Switch_example </span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-1">4;</span>
      
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">i</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">&#60;</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">4;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">++</span>     
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>  
  {"\n"} 

  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;switch</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>{"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`//Case statements`}  </span>
  {"\n"}

  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">1</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"1"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}



  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">2</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"2"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}




  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">3</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"3"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}




  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">4</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"4"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}


  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">5</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"5"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}


  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;default </span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"default value"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}


 


      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}
 
 
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}


          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-5">&nbsp;2 </span>  
          {"\n"}   
          <span className="qwerty-5">&nbsp;3 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;4 </span>
          {"\n"}
       
            </code>{"   "}
            </pre>
      </div>
    </div>

<h2 className="mt-4 mh2">For Loop Switch case Exceed range no:</h2>




<h2 className="headings">Q-Write a Program for loop Switch case Exceed range no in switch case java?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Switch_example </span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-1">4;</span>
      
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">i</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">&#60;</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">6;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">++</span>     
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>  
  {"\n"} 

  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;switch</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>{"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`//Case statements`}  </span>
  {"\n"}

  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">1</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"1"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}



  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">2</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"2"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}




  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">3</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"3"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}




  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">4</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"4"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}


  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;case </span>
  <span className="qwerty-1">5</span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"5"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}


  <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;default </span>
  <span className="qwerty-8"> : </span>
  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"default value"</span>       
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Break; </span>  
      {"\n"}


 


      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}
 
 
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
            {"\n"}


          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-5">&nbsp;2 </span>  
          {"\n"}   
          <span className="qwerty-5">&nbsp;3 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;4 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;5 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;default value </span>
          {"\n"}
       
            </code>{"   "}
            </pre>
      </div>
    </div>


  <h1 className="mt-5">  </h1>
      
  <div className="back">
        <a href="/java-conditional-operator">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-looping">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Jswitch;